"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CircularProgress_1 = __importDefault(require("../../../CircularProgress"));
var useStyles_1 = __importDefault(require("./useStyles"));
var Loader = function (_a) {
    var isLoading = _a.isLoading;
    var classes = (0, useStyles_1.default)();
    if (!isLoading)
        return null;
    return (react_1.default.createElement(CircularProgress_1.default, { color: "inherit", size: 20, classes: {
            root: classes.root
        } }));
};
exports.default = Loader;
